<template>
  <div
    style="
      width: 100%;
      display: flex;
      justify-content: flex-end;
      font-size: 7px;
      font-family: Arial, Helvetica, sans-serif;
      margin-right: 15px;
      margin-left: 20px;
    "
  >
    <div style="margin-left: 10px; padding-left: 10px;">
      <img :src="logoInBase64" alt="agency logo" height="35px" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["logoInBase64"],
};
</script>
